import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { messageContentStyles } from "./MessageContentStyles";

const chunkFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const MarkdownWrapper = styled.div`
  ${messageContentStyles}

  [data-streaming] & > * {
    animation: ${chunkFadeIn} 0.35s ease-out both;
  }

  code {
    font-family:
      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.88em;
    background: rgba(33, 33, 33, 0.07);
    border-radius: 3px;
    padding: 0.1em 0.35em;
  }

  pre {
    margin: 0.8em 0;
    border-radius: 6px;
    background: rgba(33, 33, 33, 0.07);
    padding: 0.75em 1em;
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
      font-size: 0.85em;
      border-radius: 0;
    }
  }
`;
